<template>
  <div class="insurance">
    <van-dialog
      v-model="show"
      title="中国人民财产保险股份有限公司隐私政策（微信公众号2023版）"
    >
      <p style="text-indent: 32px; text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: black"
          >本政策适用于中国人民财产保险股份有限公司（以下简称“人保财险”或“我们”）官方微信公众号网络运营平台（以下统称“网络运营平台”）所提供的各类保险产品及服务，以及其他增值服务（以下统称“我们的产品及服务”），包括但不限于机动车保险、旅游保险、意外健康保险、财产保险、行李保险、企业保险、责任保险等各类保险产品及服务。</span
        >
      </p>
      <p style="text-indent: 32px; text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: black"
          >更新日期： 2023年 5月29日</span
        >
      </p>
      <p style="text-indent: 32px; text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: black"
          >生效日期： 2023年 6月29日</span
        >
      </p>
      <p style="text-indent: 32px; text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: black"
          >如果您有任何疑问、意见或建议，请通过以下联系方式与我们联系：</span
        >
      </p>
      <p style="text-indent: 32px; text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: black"
          >个人信息保护的专门岗位人员联系方式：95518</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >本政策将帮助您了解以下内容：
        </span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >□基础功能的个人信息收集使用规则</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >□保险金融服务的个人信息收集使用规则</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >□保险周边服务的个人信息收集使用规则</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >□内容资讯与活动的个人信息收集使用规则</span
        >
      </p>
      <p
        style="
          margin-left: 15px;
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 28px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >□安全管理、权限获取说明及SDK使用情况</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >□我们如何使用Cookie等技术</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >□我们如何保护您的个人信息
        </span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >□您的权利
        </span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >□我们如何处理儿童的个人信息
        </span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >□您的个人信息如何在全球范围转移
        </span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >□本政策如何更新
        </span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >□如何联系我们</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >□关键词解释</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: black"
          >我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，遵循合法、正当、必要和诚信原则保护您的个人信息，落实权责一致、目的明确、选择同意、最小必要、确保安全、主体参与、公开透明等要求。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。
        </span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: black"
          >请在使用我们的产品及接受服务前，仔细阅读并了解本《隐私政策》。我们努力用通俗易懂、简明扼要的文字表达，并对本政策中与您的权益有重大关系的条款采用加粗方式标注，以提示您注意。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >□基础功能的个人信息收集使用规则</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: black"
          >1.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: black"
          >我们收集哪些您的个人信息</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: black"
          >（1）我们提供的业务功能（我司保留对功能模块名称调整的权利）需要依赖部分信息才得以运行。您选择使用该项业务功能，则需要向我们提供或允许我们收集的必要信息包括：</span
        >
      </p>
      <table
        cellspacing="0"
        cellpadding="0"
        style="border-collapse: collapse; margin-left: 0px; width: 100%"
      >
        <tbody>
          <tr style="height: 40px" class="firstRow">
            <td
              width="24"
              style="border: 1px solid windowtext; padding: 0px 7px"
            >
              <p
                style="
                  text-align: center;
                  line-height: normal;
                  text-autospace: none;
                "
              >
                <strong
                  ><span style="font-size: 14px; font-family: 宋体"
                    >功能模块</span
                  ></strong
                >
              </p>
            </td>
            <td
              width="41"
              style="
                border-top: 1px solid windowtext;
                border-right: 1px solid windowtext;
                border-bottom: 1px solid windowtext;
                border-image: initial;
                border-left: none;
                padding: 0px 7px;
              "
            >
              <p
                style="
                  text-align: center;
                  line-height: normal;
                  text-autospace: none;
                "
              >
                <strong
                  ><span style="font-size: 14px; font-family: 宋体"
                    >收集个人信息</span
                  ></strong
                >
              </p>
            </td>
            <td
              width="34"
              style="
                border-top: 1px solid windowtext;
                border-right: 1px solid windowtext;
                border-bottom: 1px solid windowtext;
                border-image: initial;
                border-left: none;
                padding: 0px 7px;
              "
            >
              <p
                style="
                  text-align: center;
                  line-height: normal;
                  text-autospace: none;
                "
              >
                <strong
                  ><span style="font-size: 14px; font-family: 宋体"
                    >用途</span
                  ></strong
                >
              </p>
            </td>
          </tr>
          <tr style="height: 58px">
            <td
              width="24"
              style="
                border-right: 1px solid windowtext;
                border-bottom: 1px solid windowtext;
                border-left: 1px solid windowtext;
                border-image: initial;
                border-top: none;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >注册登录</span
                >
              </p>
            </td>
            <td
              width="41"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid windowtext;
                border-right: 1px solid windowtext;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >手机号码、短信验证码、您设置的密码</span
                >
              </p>
            </td>
            <td
              width="34"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid windowtext;
                border-right: 1px solid windowtext;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >使用账号登录微信公众号</span
                >
              </p>
            </td>
          </tr>
          <tr style="height: 40px">
            <td
              width="24"
              style="
                border-right: 1px solid windowtext;
                border-bottom: 1px solid windowtext;
                border-left: 1px solid windowtext;
                border-image: initial;
                border-top: none;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >完善、修改用户资料</span
                >
              </p>
            </td>
            <td
              width="41"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid windowtext;
                border-right: 1px solid windowtext;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >姓名、证件号、手机号</span
                >
              </p>
            </td>
            <td
              width="34"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid windowtext;
                border-right: 1px solid windowtext;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >用于用户完善、修改资料</span
                >
              </p>
            </td>
          </tr>
          <tr style="height: 40px">
            <td
              width="24"
              style="
                border-right: 1px solid windowtext;
                border-bottom: 1px solid windowtext;
                border-left: 1px solid windowtext;
                border-image: initial;
                border-top: none;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >短信推送</span
                >
              </p>
            </td>
            <td
              width="41"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid windowtext;
                border-right: 1px solid windowtext;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >手机号、姓名、车牌号、保单号、报案号</span
                >
              </p>
            </td>
            <td
              width="34"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid windowtext;
                border-right: 1px solid windowtext;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >发送短信用于登陆注册、视频理赔、电子签名、上传单证、他人代为办理服务授权、续保提醒、保单查询、电子保单和电子发票下载等功能时的身份核验</span
                >
              </p>
            </td>
          </tr>
          <tr style="height: 40px">
            <td
              width="24"
              style="
                border-right: 1px solid windowtext;
                border-bottom: 1px solid windowtext;
                border-left: 1px solid windowtext;
                border-image: initial;
                border-top: none;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >模板消息推送</span
                >
              </p>
            </td>
            <td
              width="41"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid windowtext;
                border-right: 1px solid windowtext;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >微信公众号unionid、微信公众号openid、手机号、姓名、证件号、证件类型，以及对应服务的保单信息、服务信息、理赔信息</span
                >
              </p>
            </td>
            <td
              width="34"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid windowtext;
                border-right: 1px solid windowtext;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >用以通过推送模板消息为客户提供服务</span
                >
              </p>
            </td>
          </tr>
          <tr style="height: 40px">
            <td
              width="24"
              style="
                border-right: 1px solid windowtext;
                border-bottom: 1px solid windowtext;
                border-left: 1px solid windowtext;
                border-image: initial;
                border-top: none;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >常用信息</span
                >
              </p>
            </td>
            <td
              width="41"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid windowtext;
                border-right: 1px solid windowtext;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >常用联系人：姓名、证件类型、证件号、性别、出生日期、社保情况、账号关系、手机号、电子邮箱</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >常用收货地址：收件人、手机号、所在城市、邮政编码</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >常用地址：地址、邮政编码</span
                >
              </p>
            </td>
            <td
              width="34"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid windowtext;
                border-right: 1px solid windowtext;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >用户自主维护，用于快速办理平台业务及备忘</span
                >
              </p>
            </td>
          </tr>
          <tr style="height: 40px">
            <td
              width="24"
              style="
                border-right: 1px solid windowtext;
                border-bottom: 1px solid windowtext;
                border-left: 1px solid windowtext;
                border-image: initial;
                border-top: none;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >我的车辆</span
                >
              </p>
            </td>
            <td
              width="41"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid windowtext;
                border-right: 1px solid windowtext;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >车牌号、保单号、车架号、发动机号、车主手机号、车主身份证号、发动机号、使用性质、座位数、注册日期、交强险保险公司、交强险日期、商业险保险公司、商业险日期</span
                >
              </p>
            </td>
            <td
              width="34"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid windowtext;
                border-right: 1px solid windowtext;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >用户绑定车辆，便捷使用服务</span
                >
              </p>
            </td>
          </tr>
          <tr style="height: 113px">
            <td
              width="24"
              style="
                border-right: 1px solid windowtext;
                border-bottom: 1px solid windowtext;
                border-left: 1px solid windowtext;
                border-image: initial;
                border-top: none;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >人脸认证</span
                >
              </p>
            </td>
            <td
              width="41"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid windowtext;
                border-right: 1px solid windowtext;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >姓名、身份证号、人脸照片或人脸视频</span
                >
              </p>
            </td>
            <td
              width="34"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid windowtext;
                border-right: 1px solid windowtext;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >在您同意使用面部识别核验身份的前提下，通过刷脸判断您身份的真实性，以确保您的账号安全</span
                >
              </p>
            </td>
          </tr>
          <tr style="height: 40px">
            <td
              width="24"
              style="
                border-right: 1px solid windowtext;
                border-bottom: 1px solid windowtext;
                border-left: 1px solid windowtext;
                border-image: initial;
                border-top: none;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >功能授权</span
                >
              </p>
            </td>
            <td
              width="41"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid windowtext;
                border-right: 1px solid windowtext;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >被授权人手机号、被授权关系、被保险人车牌号、被保险人姓名、被保险人证件号、授权功能</span
                >
              </p>
            </td>
            <td
              width="34"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid windowtext;
                border-right: 1px solid windowtext;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >用于授权赔案查询、在线报案、微信救援、礼包查询、卡券包、保单查询功能，授权成功后，被授权人在授权功能中，与授权人有同样的操作权限</span
                >
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p style="text-indent: 32px; text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（2）您可自主选择向我们提供或允许我们收集下列信息：</span
        >
      </p>
      <p style="text-indent: 32px; text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312">&nbsp;</span>
      </p>
      <table
        cellspacing="0"
        cellpadding="0"
        style="border-collapse: collapse; margin-left: 0px; width: 100%"
      >
        <tbody>
          <tr style="height: 40px" class="firstRow">
            <td
              width="24"
              style="border: 1px solid windowtext; padding: 0px 7px"
            >
              <p
                style="
                  text-align: center;
                  line-height: normal;
                  text-autospace: none;
                "
              >
                <strong
                  ><span style="font-size: 14px; font-family: 宋体"
                    >功能模块</span
                  ></strong
                >
              </p>
            </td>
            <td
              width="40"
              style="
                border-top: 1px solid windowtext;
                border-right: 1px solid windowtext;
                border-bottom: 1px solid windowtext;
                border-image: initial;
                border-left: none;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <strong
                  ><span style="font-size: 14px; font-family: 宋体"
                    >收集个人信息</span
                  ></strong
                >
              </p>
            </td>
            <td
              width="34"
              style="
                border-top: 1px solid windowtext;
                border-right: 1px solid windowtext;
                border-bottom: 1px solid windowtext;
                border-image: initial;
                border-left: none;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <strong
                  ><span style="font-size: 14px; font-family: 宋体"
                    >用途</span
                  ></strong
                >
              </p>
            </td>
          </tr>
          <tr style="height: 58px">
            <td
              width="24"
              style="
                border-right: 1px solid windowtext;
                border-bottom: 1px solid windowtext;
                border-left: 1px solid windowtext;
                border-image: initial;
                border-top: none;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >推送</span
                >
              </p>
            </td>
            <td
              width="40"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid windowtext;
                border-right: 1px solid windowtext;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >微信公众号unionid、微信公众号openid、手机号、姓名、证件号、证件类型，以及对应服务的保单信息、服务信息、理赔信息</span
                >
              </p>
            </td>
            <td
              width="34"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid windowtext;
                border-right: 1px solid windowtext;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >用于实现推送微信图文、推送微信模板消息、推送微信客服消息、推送二维码消息、推送微信图片消息</span
                >
              </p>
            </td>
          </tr>
          <tr style="height: 40px">
            <td
              width="24"
              style="
                border-right: 1px solid windowtext;
                border-bottom: 1px solid windowtext;
                border-left: 1px solid windowtext;
                border-image: initial;
                border-top: none;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >分享</span
                >
              </p>
            </td>
            <td
              width="40"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid windowtext;
                border-right: 1px solid windowtext;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >用户昵称、用户头像、微信公众号unionid、微信公众号openid；</span
                >
              </p>
            </td>
            <td
              width="34"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid windowtext;
                border-right: 1px solid windowtext;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >用于在微信环境中分享、转发</span
                >
              </p>
            </td>
          </tr>
          <tr style="height: 40px">
            <td
              width="24"
              style="
                border-right: 1px solid windowtext;
                border-bottom: 1px solid windowtext;
                border-left: 1px solid windowtext;
                border-image: initial;
                border-top: none;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >公众号首页</span
                >
              </p>
            </td>
            <td
              width="40"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid windowtext;
                border-right: 1px solid windowtext;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >用户GPS定位信息</span
                >
              </p>
            </td>
            <td
              width="34"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid windowtext;
                border-right: 1px solid windowtext;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >用于展示当地微信公众号首页</span
                >
              </p>
            </td>
          </tr>
          <tr style="height: 40px">
            <td
              width="24"
              style="
                border-right: 1px solid windowtext;
                border-bottom: 1px solid windowtext;
                border-left: 1px solid windowtext;
                border-image: initial;
                border-top: none;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >公众号选择归属地市</span
                >
              </p>
            </td>
            <td
              width="40"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid windowtext;
                border-right: 1px solid windowtext;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >用户GPS定位信息</span
                >
              </p>
            </td>
            <td
              width="34"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid windowtext;
                border-right: 1px solid windowtext;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >用于默认归属地在微信公众号选择归属地市页面进行展示</span
                >
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p style="text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312">&nbsp;</span>
      </p>
      <p style="text-indent: 32px; text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >这些信息并非基础功能运行所必需，但这些信息对改善服务质量有非常重要的意义。我们不会强制要求您提供这些信息，您如拒绝不会对使用基础功能产生不利影响。</span
        >
      </p>
      <p style="text-indent: 32px; text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（3）开启相关设备权限
        </span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >您需要在您的设备中向我们开启设备状态、网络数据、摄像头、录制音频、已安装应用列表、地理位置、存储、相册、电话访问权限，以收集和使用基础功能对应服务所需要的个人信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >您开启这些访问权限即代表您同意提供或授权我们可以收集和使用这些个人信息来实现上述功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集您的这些个人信息，也无法为您提供与这些授权所对应功能相关的服</span
          ></strong
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >务<strong>。</strong></span
        ><strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >除上述权限之外，您可自主选择是否额外授予本微信公众号其他的系统权限。</span
          ></strong
        >
      </p>
      <p style="text-indent: 32px; text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312">2.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们如何使用您的个人信息</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（1）对于必要的个人信息，我们会用来提供该项业务功能，包括登录注册、完善、修改用户资料、微信模板消息推送、短信推送、常用信息、我的车辆、实名认证、人脸认证、功能授权。我们也会使用上述信息来维护和改进本项业务功能。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >为了准确核验您的身份，防止您的身份被冒用，您授权我们通过中国人保财险微信公众号采集您的设备信息以验证您在进行认证时处于安全可信的环境。当您使用人脸识别的方式进行身份核验时，您点击同意后，即视为您同意并授权我们/服务提供方获取身份验证结果。我们不会超过本协议告知的范围收集使用您的人脸信息，如您不同意提交或授权，请不要点击
            “同意授权并继续”按钮，同时您将无法继续使用人脸识别功能，但这并不影响您使用本微信公众号的其他服务。</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（2）
          对于非必要的个人信息，我们会用于以下用途，包括推送、分享、根据GPS定位展示公众号首页、公众号归属地选择。</span
        >
      </p>
      <p style="text-indent: 32px; text-autospace: none">
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >&nbsp;</span
          ></strong
        >
      </p>
      <p style="text-indent: 32px; text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312">3.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们如何委托处理、共享、转让或公开披露您的个人信息</span
        >
      </p>
      <p style="text-indent: 32px; text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（1）委托处理</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >本业务功能中某些具体的模块或功能由外部供应商提供。例如我们会聘请服务提供商来协助我们提供客户支持。对我们委托处理个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的要求、本个人信息保护政策以及其他任何相关的保密和安全措施来处理个人信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">（2）共享</span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们不会与其它公司、组织和个人共享您的个人信息，但以下情况除外：</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">a</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）在获取授权同意的情况下共享：获得您的单独同意后，我们可在人保集团内部共享（范围详见下文）或与被授权方（范围见下文）共享您的个人信息。</span
        >
      </p>
      <p style="text-indent: 32px; text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >人保集团内部共享：为了向您提供基础功能，我们会将您的个人信息在人保集团内部进行共享。<strong
            >在您同意本隐私政策的前提下，您的账号及实名认证后的个人信息将在人保集团内部共享，以便您登录人保集团内部的线上运营平台更加便捷，<a
            ></a><a>包括</a></strong
          ></span
        ><a href="https://www.picc.com/"
          ><strong
            ><span
              style="
                font-size: 16px;
                font-family: 仿宋_GB2312;
                color: windowtext;
                text-underline: none;
              "
              >中国人民保险集团股份有限公司</span
            ></strong
          ></a
        ><strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >、</span
          ></strong
        ><a
          href="https://www.picc.com/gyrb/jtjs/zgsjs/202109/t20210917_28850.html"
          ><strong
            ><span
              style="
                font-size: 16px;
                font-family: 仿宋_GB2312;
                color: windowtext;
                text-underline: none;
              "
              >中国人民人寿保险股份有限公司</span
            ></strong
          ></a
        ><strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >、</span
          ></strong
        ><a
          href="https://www.picc.com/gyrb/jtjs/zgsjs/202109/t20210917_28847.html"
          ><strong
            ><span
              style="
                font-size: 16px;
                font-family: 仿宋_GB2312;
                color: windowtext;
                text-underline: none;
              "
              >中国人民健康保险股份有限公司</span
            ></strong
          ></a
        ><strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >、</span
          ></strong
        ><a
          href="https://www.picc.com/gyrb/jtjs/zgsjs/202109/t20210917_28846.html"
          ><strong
            ><span
              style="
                font-size: 16px;
                font-family: 仿宋_GB2312;
                color: windowtext;
                text-underline: none;
              "
              >中国人民养老保险有限责任公司</span
            ></strong
          ></a
        ><strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >、</span
          ></strong
        ><a
          href="https://www.picc.com/gyrb/jtjs/zgsjs/202109/t20210917_28841.html"
          ><strong
            ><span
              style="
                font-size: 16px;
                font-family: 仿宋_GB2312;
                color: windowtext;
                text-underline: none;
              "
              >人保金融服务有限公司</span
            ></strong
          ></a
        ><strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >、</span
          ></strong
        ><a
          href="https://www.picc.com/gyrb/jtjs/zgsjs/202203/t20220314_42081.html"
          ><strong
            ><span
              style="
                font-size: 16px;
                font-family: 仿宋_GB2312;
                color: windowtext;
                text-underline: none;
              "
              >人保信息科技有限公司</span
            ></strong
          ></a
        ><strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >，您可点击查看相关公司具体介绍。前述涉及公司的介绍会在使用相关服务的跳转页面注明。</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们只会共享必要的个人信息，且这种共享受本政策所声明目的约束。人保集团内部其他成员如要改变本隐私政策声明的个人信息使用目的，将再次征求您的授权同意。除非得到您的明确授权或根据相关法律法规及监管规定要求，我们绝不会在未经您同意的情况下在人保集团内部共享您的敏感个人信息。</span
        >
      </p>
      <p style="text-indent: 32px; text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >与人保集团外被授权方共享：仅为实现本政策声明的目的，我们的某些服务将由人保集团外的被授权方提供（详见下文“SDK使用情况”）。我们可能会与被授权方共享您的某些个人信息，以提供更好的客户服务和用户体验。目前，我们会在以下情形中，向您征求您对共享个人信息的授权同意：为准确核实您的身份信息以便为您提供服务，您同意并授权我们将您的证件信息、人脸信息提供给公安部进行身份验证。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们的被授权方无权将共享的个人信息用于任何其他用途。除非得到您的明确授权或相关法律法规及监管规定要求，我们绝不会在未经您同意的情况下与被授权方共享您的敏感个人信息。</span
        >
      </p>
      <p style="text-indent: 32px; text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312">b</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）对与我们共享您个人信息的被授权方，我们将与其签署严格的保密协议，要求其在合作结束后将您的个人信息交还我们保存，同时删除其保存的相应个人信息副本并允许我们进行核查。对于人保集团内部其他成员，我们也会要求其严格执行人保集团的个人信息保密制度。人保集团内部其他成员和被授权方将按照本隐私政策规定，并采取有效的保密和安全措施来处理个人信息。</span
        >
      </p>
      <p style="text-indent: 32px; text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312">c</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）匿名化处理后共享：根据《中华人民共和国网络安全法》《中华人民共和国个人信息保护法》等法律规定，无法识别自然人个人身份的信息不属于个人信息。因此，如我们对您的个人信息进行匿名化处理，无法识别或关联特定个人且不能复原的，依法可在人保集团内部或与其他方共享。</span
        >
      </p>
      <p style="text-indent: 32px; text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312">d</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）根据法律法规或按政府主管部门的强制性要求对外提供或共享：例如，根据网络服务实名制管理要求和金融监管机构相关规定，为保证我们为您提供服务的连续性、真实性，我们需要将您的身份信息（姓名、证件类型、证件号、手机号、地理位置）提交给政府主管部门或其指定的相关机构对您的个人信息进行核验；将您及出险人的身份信息（包括姓名、证件号码等），按监管机构要求向保单登记平台进行数据报送。</span
        >
      </p>
      <p style="text-indent: 32px; text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312">&nbsp;</span>
      </p>
      <p style="text-indent: 32px; text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312">（3）转让</span>
      </p>
      <p style="text-indent: 32px; text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们不会将您的个人信息转让给任何公司、组织和个人，但以下情形除外：</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">a</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；我们将向您告知接收方的名称或者姓名、联系方式、处理目的、处理方式和个人信息的种类，接收方不得超出上述权限处理您的个人信息，除非重新取得您的同意。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">b</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受此个人信息保护政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（4）公开披露</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们不会公开披露您的个人信息，但以下情况除外：</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">a</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）获得您明确同意后；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">b</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）基于法律要求的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >4.</span
          ></strong
        ><strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >敏感个人信息的处理规则</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >对于基础功能收集的敏感个人信息，我们将采用首次进入弹窗、登录时提示等方式向您进行告知，并取得您的单独同意，并明确告知您拒绝提供或者拒绝同意将带来的影响，例如您将无法使用相应的业务功能，以确保您在完全知情的基础上决定是否提供或授权我们查询、收集、共享您的敏感个人信息。</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >法律、行政法规对处理敏感个人信息规定应当取得相关行政许可或者作出其他限制的，我们将按照其规定处理。</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >&nbsp;</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >□<strong>保险金融服务的个人信息收集使用规则</strong></span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">1.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们收集哪些您的个人信息</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（1）我们提供的业务功能（我司保留对功能模块名称调整的权利）需要依赖部分信息才得以运行。您选择使用该项业务功能，则需要向我们提供或允许我们收集的必要信息包括：</span
        >
      </p>
      <table
        cellspacing="0"
        cellpadding="0"
        style="border-collapse: collapse; margin-left: 0px; width: 100%"
      >
        <tbody>
          <tr style="height: 30px" class="firstRow">
            <td style="border: 1px solid black; padding: 0px 7px">
              <p
                style="
                  text-align: center;
                  line-height: normal;
                  text-autospace: none;
                "
              >
                <strong
                  ><span style="font-size: 14px; font-family: 宋体"
                    >功能模块</span
                  ></strong
                >
              </p>
            </td>
            <td
              style="
                border-top: 1px solid black;
                border-right: 1px solid black;
                border-bottom: 1px solid black;
                border-image: initial;
                border-left: none;
                padding: 0px 7px;
              "
            >
              <p
                style="
                  text-align: center;
                  line-height: normal;
                  text-autospace: none;
                "
              >
                <strong
                  ><span style="font-size: 14px; font-family: 宋体"
                    >收集个人信息</span
                  ></strong
                >
              </p>
            </td>
            <td
              width="100"
              style="
                border-top: 1px solid black;
                border-right: 1px solid black;
                border-bottom: 1px solid black;
                border-image: initial;
                border-left: none;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <strong
                  ><span style="font-size: 14px; font-family: 宋体"
                    >用途</span
                  ></strong
                >
              </p>
            </td>
          </tr>
          <tr style="height: 40px">
            <td
              style="
                border-right: 1px solid black;
                border-bottom: 1px solid black;
                border-left: 1px solid black;
                border-image: initial;
                border-top: none;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >车险投保</span
                >
              </p>
            </td>
            <td
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid black;
                border-right: 1px solid black;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >行驶城市、车牌号、手机号码、车辆识别码/车架号、发动机号码、品牌型号、核定载客量、注册日期、车主姓名、证件类型、证件号、证件地址、OCR识别行驶证、发票、新车合格证、身份证（地区政策不同强制管控稍有差异）、被保险人姓名、投保人姓名、联系人、联系方式、常住地址</span
                >
              </p>
            </td>
            <td
              width="100"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid black;
                border-right: 1px solid black;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >1</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >、姓名、证件号、手机号、是否实名认证用于确认投保人、被保人、车主的个人身份证真实性</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >2</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >、车辆信息用于确认标的信息，以便完成承保</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >3</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >、地理位置信息，用于确认用户投保所在的城市</span
                >
              </p>
            </td>
          </tr>
          <tr style="height: 40px">
            <td
              style="
                border-right: 1px solid black;
                border-bottom: 1px solid black;
                border-left: 1px solid black;
                border-image: initial;
                border-top: none;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >非车险产品投保（包括企业财产保险、普通家财保险、普通意外保险、普通健康保险（非专项）、责任保险、一揽子保险、人身险、宠物险等）</span
                >
              </p>
            </td>
            <td
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid black;
                border-right: 1px solid black;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >1.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >通用：投保人姓名、被保人姓名、企业名称/单位名称、证件号码、常住地址、详细地址、手机号码、电子邮箱</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >2.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >企业：联系人姓名、联系人名称、联系人手机、联系人手机号、联系人地址、邮编、企业名称、投保机构名称、统一社会信用代码、企业地址、招牌名称、雇员人数、营业地址、营业面积（㎡）、区/街乡镇、营业面积</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >3.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >医疗：上年度营业收入、医生人数、护士人数、医院总人数、医技人数、年手术人次、年诊疗人次、床位数、年住院人数、医护人员姓名、身份证号码</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >4.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >学校：学校名称、班级名称</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >详细地址</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >5.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >保修：投保时里程数</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >6.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >车辆：GPS定位设备编号、号牌号码、车牌号码、发动机号、电机号、车架号、车辆识别码/车架号、厂牌型号、车辆识别代号车型代码</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >7.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >燃气：燃气IC卡号</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >8.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >土地信息：亩数、土地详细地址</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >9.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >航班：航班号</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >10.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >货车：集装箱号、国别、货物名称、数量/重量(KG)、运单号/提单号、启运地、目的地</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >11.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >宠物：宠物姓名、宠物犬的芯片编号、宠物鼻纹拍照获取编码、宠物年龄、宠物品种、宠物毛色、毛色、宠物体重(kg)</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >12.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >家电：家电数量</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >13.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >随车非车险：被保险人姓名、证件类型、证件号码</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >14</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >：财产：房屋所在地/城市；详细地址；左邻、右邻</span
                >
              </p>
            </td>
            <td
              width="100"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid black;
                border-right: 1px solid black;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >用于用户非车险投保</span
                >
              </p>
            </td>
          </tr>
          <tr style="height: 40px">
            <td
              style="
                border-right: 1px solid black;
                border-bottom: 1px solid black;
                border-left: 1px solid black;
                border-image: initial;
                border-top: none;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >理赔服务</span
                >
              </p>
            </td>
            <td
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid black;
                border-right: 1px solid black;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >1.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >理赔聚合页、理赔单证、理赔查询页：用户GPS定位信息</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >2.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >综治理赔：报案号、验证码</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >3.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >视频报案：车牌号/vin码、事故照片、证件照片</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >4.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >车险报案-单车：用户GPS定位信息、车牌号、事故时间、事故地点、财产损失信息、事故现场全景照片（前）、事故现场全景照片（后）、损失部位照片、行驶证正副本照片、驾驶证正副本照片、身份证正面照片、身份证背面照片、财产损失照片</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >5.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >车险报案-双车：用户GPS定位信息、本车车牌号、对方车牌号、事故时间、事故地点、财产损失信息</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >6.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >车险报案-多方事故、涉人伤报案：本车车牌号、其他车辆车牌号、事故地点、事故时间、财产损失信息</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >7.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >车险报案-通赔报案：用户GPS定位信息、本车车牌号、事故时间、事故地点、维修地点</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >8.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >车险报案-大灾报案：用户GPS定位信息、车牌号/VIN码、出险时间、出险地点、出险原因、是否水淹车、水浸高度、是否需要施救、车辆停放位置、是否可立即拖车、车辆手刹情况</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >9.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >非车险报案：用户GPS定位信息、保单号码、出险日期、出险原因、出险经过、出险地点、索赔金额、报案人姓名、报案人手机号码、出险人姓名、出险人电话、出险人证件类型、证件号码、年龄、联系人姓名、联系人电话、与出险人关系证明（户口簿、出生证）、就医类型、索赔项目、医疗票据、门急诊病历、住院病历、检查报告、事故证明和其他材料、交通费误工费护理费材料、房产证或租赁合同、关系证明、财产损失资料、行驶证、驾驶证、乘机证明、第三者伤者身份证正反面或户口簿、三者联系电话、被保险人与伤者的赔偿协议与支付凭证、领款人身份证正反面、银行卡正面、领款人与被保险人关系证明、银行名称、省份、城市、开户行;</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >10.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >电子签名：被保险人姓名、被保险人身份证号码、实物赔付确认书(标的、三者)电子签名、车辆损失确认书（标的、三者）电子签名、索赔申请书电子签名、放弃索赔声明电子签名、人伤索赔须知电子签名、财产损失确认书电子签名、自行协商确认书电子签名；</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >11.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >上传照片-车险：车牌号、报案号、手机号、事故现场全景照片（前）、事故现场全景照片（后）、损失部位照片、财产损失照片、行驶证正副本照片、驾驶证正副本照片、身份证正面照片、身份证背面照片、(对方行驶证正副本照片、对方驾驶证正副本照片、对方驾驶人身份证正面照片、对方驾驶人身份证反面照片)、交警认定书/自行协商确认书、</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >12.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >申请赔款-车险：银行卡正面照片、已支付三者方赔款证明照片、4S店维修发票、事故责任证明材料；</span
                >
              </p>
            </td>
            <td
              width="100"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid black;
                border-right: 1px solid black;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >用于用户出险后办理理赔案件，上传理赔材料、录入支付信息、签署授权协议、获取赔款</span
                >
              </p>
            </td>
          </tr>
          <tr style="height: 40px">
            <td
              style="
                border-right: 1px solid black;
                border-bottom: 1px solid black;
                border-left: 1px solid black;
                border-image: initial;
                border-top: none;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >保单服务（包括保单查询、保单验真、新车批改、视频批改、电子发票等）</span
                >
              </p>
            </td>
            <td
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid black;
                border-right: 1px solid black;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >投保地区、学校名称、手机号码、投保人及被保险人姓名、证件类型、证件号码、出生日期、保单号、车牌号、车架号、是否实名认证、声纹识别、微信昵称、微信头像、接收邮箱、纳税人识别号、VIN码、承保地区省市</span
                >
              </p>
            </td>
            <td
              width="100"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid black;
                border-right: 1px solid black;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >用户匹配保险订单、完成保单查询、接收电子发票、进行新车号牌批改和视频批改</span
                >
              </p>
            </td>
          </tr>
          <tr style="height: 50px">
            <td
              style="
                border-right: 1px solid black;
                border-bottom: 1px solid black;
                border-left: 1px solid black;
                border-image: initial;
                border-top: none;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >我的订单</span
                >
              </p>
            </td>
            <td
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid black;
                border-right: 1px solid black;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >微信公众号openid、保险订单号、用户GPS定位信息、用户entry
                  id以及保单服务模块匹配信息</span
                >
              </p>
            </td>
            <td
              width="100"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid black;
                border-right: 1px solid black;
                padding: 0px 7px;
              "
            ></td>
          </tr>
          <tr style="height: 50px">
            <td
              style="
                border-right: 1px solid black;
                border-bottom: 1px solid black;
                border-left: 1px solid black;
                border-image: initial;
                border-top: none;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >一键续保</span
                >
              </p>
            </td>
            <td
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid black;
                border-right: 1px solid black;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >姓名、手机号码、证件类型、证件号码、用户GPS定位信息、客户保单信息</span
                >
              </p>
            </td>
            <td
              width="100"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid black;
                border-right: 1px solid black;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >用于完成用户一键续保</span
                >
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p style="text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312">&nbsp;</span>
      </p>
      <p style="text-indent: 32px; text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（2）开启相关设备权限
        </span>
      </p>
      <p style="text-indent: 32px; text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >您需要在您的设备中向我们开启设备状态、网络数据、摄像头、录制音频、已安装应用列表、地理位置、存储、相册、电话访问权限，以收集和使用保险金融服务对应服务所需要的个人信息。您开启这些访问权限即代表您同意提供或授权我们可以收集和使用这些个人信息来实现上述功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集您的这些个人信息，也无法为您提供与这些授权所对应功能相关的服务。除上述权限之外，您可自主选择是否额外授予中国人保财险微信公众号其他的系统权限。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（3）您授权我们从第三方查询和收集个人信息的情形</span
        >
      </p>
      <p style="text-indent: 32px; text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >为通过本微信公众号的保险金融服务向您提供产品及服务，您需要授权我们在法律法规及监管规定允许的范围内，从人保集团内部（</span
        ><strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >包括<a href="https://www.picc.com/"
              ><span style="color: windowtext; text-underline: none"
                >中国人民保险集团股份有限公司</span
              ></a
            >、<a
              href="https://www.picc.com/gyrb/jtjs/zgsjs/202109/t20210917_28850.html"
              ><span style="color: windowtext; text-underline: none"
                >中国人民人寿保险股份有限公司</span
              ></a
            >、<a
              href="https://www.picc.com/gyrb/jtjs/zgsjs/202109/t20210917_28847.html"
              ><span style="color: windowtext; text-underline: none"
                >中国人民健康保险股份有限公司</span
              ></a
            >、<a
              href="https://www.picc.com/gyrb/jtjs/zgsjs/202109/t20210917_28846.html"
              ><span style="color: windowtext; text-underline: none"
                >中国人民养老保险有限责任公司</span
              ></a
            >、<a
              href="https://www.picc.com/gyrb/jtjs/zgsjs/202109/t20210917_28841.html"
              ><span style="color: windowtext; text-underline: none"
                >人保金融服务有限公司</span
              ></a
            >、<a
              href="https://www.picc.com/gyrb/jtjs/zgsjs/202203/t20220314_42081.html"
              ><span style="color: windowtext; text-underline: none"
                >人保信息科技有限公司</span
              ></a
            ></span
          ></strong
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）查询和收集您的保单信息（保单号、保障期限、被保险人保障责任）、理赔信息（报案号、理赔进度）、保全变更信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">2.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们如何使用您的个人信息</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >对于必要的个人信息，我们会用来提供该项业务功能，包括车险投保、非车险投保、理赔服务、订单服务、保单查询和批改服务、一键续保、增值服务。我们也会使用上述个人信息来维护和改进本项业务功能。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">3.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们如何委托处理、共享、转让或公开披露您的个人信息</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（1）委托处理</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >本业务功能中某些具体的模块或功能由外部供应商提供。例如我们会聘请服务提供商来协助我们提供客户支持。对我们委托处理个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的要求、本个人信息保护政策以及其他任何相关的保密和安全措施来处理个人信息。</span
        >
      </p>
      <p style="text-indent: 32px; text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312">（2）共享</span>
      </p>
      <p style="text-indent: 32px; text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们不会与其它公司、组织和个人共享您的个人信息，但以下情况除外：</span
        >
      </p>
      <p style="text-indent: 32px; text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312">a</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）在获取授权同意的情况下共享：获得您的单独同意后，我们可在人保集团内部共享您的个人信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >人保集团内部共享：为了向您提供金融保险服务，我们会将您的个人信息在人保集团内部进行共享。<strong
            >保险金融服务由中国人民保险集团股份有限公司及其内部子公司提供，因此只有共享您的信息，才能提供您需要的产品或服务。您在购买保险并享受保单服务、理赔服务时，我们需要将您的个人信息及保险标的信息提供给人保集团相应子公司以为您提供服务，包括</strong
          ></span
        ><strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >包括<a href="https://www.picc.com/"
              ><span style="color: windowtext; text-underline: none"
                >中国人民保险集团股份有限公司</span
              ></a
            >、<a
              href="https://www.picc.com/gyrb/jtjs/zgsjs/202109/t20210917_28850.html"
              ><span style="color: windowtext; text-underline: none"
                >中国人民人寿保险股份有限公司</span
              ></a
            >、<a
              href="https://www.picc.com/gyrb/jtjs/zgsjs/202109/t20210917_28847.html"
              ><span style="color: windowtext; text-underline: none"
                >中国人民健康保险股份有限公司</span
              ></a
            >、<a
              href="https://www.picc.com/gyrb/jtjs/zgsjs/202109/t20210917_28846.html"
              ><span style="color: windowtext; text-underline: none"
                >中国人民养老保险有限责任公司</span
              ></a
            >、<a
              href="https://www.picc.com/gyrb/jtjs/zgsjs/202109/t20210917_28841.html"
              ><span style="color: windowtext; text-underline: none"
                >人保金融服务有限公司</span
              ></a
            >、<a
              href="https://www.picc.com/gyrb/jtjs/zgsjs/202203/t20220314_42081.html"
              ><span style="color: windowtext; text-underline: none"
                >人保信息科技有限公司</span
              ></a
            >，您可点击查看相关公司具体介绍。</span
          ></strong
        ><strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >为保证您合规的完成购买流程，涉及公司会在购买页面注明。</span
          ></strong
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们只会共享必要的个人信息，且这种共享受本隐私政策所声明目的约束。人保集团内部其他成员如要改变本隐私政策声明的个人信息使用目的，将再次征求您的授权同意。除非得到您的明确授权或根据相关法律法规及监管规定要求，我们绝不会在未经您同意的情况下在人保集团内部共享您的敏感个人信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >与人保集团外被授权方共享：仅为实现本政策声明的目的，我们的某些服务将由人保集团外的被授权方提供（详见下文“SDK使用情况”）。我们可能会与被授权方共享您的某些个人信息，以提供更好的客户服务和用户体验。目前，我们会在以下情形中，向您征求您对共享个人信息的授权同意：为准确核实您的身份信息，您同意并授权我们将您的证件信息、人脸信息提供给全国车险信息平台、公安部进行身份验证。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们的被授权方无权将共享的个人信息用于任何其他用途。除非得到您的明确授权或相关法律法规及监管规定要求，我们绝不会在未经您同意的情况下与被授权方共享您的敏感个人信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">b</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）对与我们共享您的个人信息的被授权方，我们将与其签署严格的保密协议，要求其在合作结束后将您的个人信息交还我们保存，同时删除其保存的相应个人信息副本并允许我们进行核查。对于人保集团内部其他成员，我们也会要求其严格执行人保集团的个人信息保密制度。人保集团内部其他成员和被授权方将按照本隐私政策规定，并采取有效的保密和安全措施来处理个人信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">c</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）匿名化处理后共享：根据《中华人民共和国网络安全法》《中华人民共和国个人信息保护法》等法律规定，无法识别自然人个人身份的信息不属于个人信息。因此，如我们对您的个人信息进行匿名化处理，无法识别或关联特定个人且不能复原的，依法可在人保集团内部或与其他方共享。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">d</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）根据法律法规或按政府主管部门的强制性要求对外提供或共享：例如，根据网络服务实名制管理要求和金融监管机构相关规定，为保证我们为您提供服务的连续性、真实性，我们需要将您的身份信息（姓名、证件类型、证件号、手机号、地理位置）提交给政府主管部门或其指定的相关机构对您的个人信息进行核验；将您及出险人的身份信息（包括姓名、证件号码等），按监管机构要求向保单登记平台进行数据报送。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">（3）转让</span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们不会将您的个人信息转让给任何公司、组织和个人，但以下情形除外：</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">a</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；我们将向您告知接收方的名称或者姓名、联系方式、处理目的、处理方式和个人信息的种类，接收方不得超出上述权限处理您的个人信息，除非重新取得您的同意。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">b</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（4）公开披露</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们不会公开披露您的个人信息，但以下情况除外：</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">a</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）获得您明确同意后；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">b</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）基于法律要求的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >4.</span
          ></strong
        ><strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >敏感个人信息的处理规则</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >对于保险金融服务收集的敏感个人信息，我们将采用首次进入弹窗、登录时提示等方式向您进行告知，并取得您的单独同意，明确告知您拒绝提供或者拒绝同意将带来的影响，例如您将无法使用相应的业务功能，以确保您在完全知情的基础上决定是否提供或授权我们查询、收集、共享您的敏感个人信息。</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >法律、行政法规对处理敏感个人信息规定应当取得相关行政许可或者作出其他限制的，我们将按照其规定处理。</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >&nbsp;</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >□<strong>保险周边服务的个人信息收集使用规则</strong></span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">1.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们收集哪些您的个人信息</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（1）我们提供的业务功能（我司保留对功能模块名称调整的权利）需要依赖部分信息才得以运行。您选择使用该项业务功能，则需要向我们提供或允许我们收集的必要信息包括：</span
        >
      </p>
      <table
        cellspacing="0"
        cellpadding="0"
        style="border-collapse: collapse; margin-left: 0px; width: 100%"
      >
        <tbody>
          <tr style="height: 30px" class="firstRow">
            <td width="143" style="border: 1px solid black; padding: 0px 7px">
              <p
                style="
                  text-align: center;
                  line-height: normal;
                  text-autospace: none;
                "
              >
                <strong
                  ><span style="font-size: 14px; font-family: 宋体"
                    >功能模块</span
                  ></strong
                >
              </p>
            </td>
            <td
              width="175"
              style="
                border-top: 1px solid black;
                border-right: 1px solid black;
                border-bottom: 1px solid black;
                border-image: initial;
                border-left: none;
                padding: 0px 7px;
              "
            >
              <p
                style="
                  text-align: center;
                  line-height: normal;
                  text-autospace: none;
                "
              >
                <strong
                  ><span style="font-size: 14px; font-family: 宋体"
                    >收集个人信息</span
                  ></strong
                >
              </p>
            </td>
            <td
              width="148"
              style="
                border-top: 1px solid black;
                border-right: 1px solid black;
                border-bottom: 1px solid black;
                border-image: initial;
                border-left: none;
                padding: 0px 7px;
              "
            >
              <p
                style="
                  text-align: center;
                  line-height: normal;
                  text-autospace: none;
                "
              >
                <strong
                  ><span style="font-size: 14px; font-family: 宋体"
                    >用途</span
                  ></strong
                >
              </p>
            </td>
          </tr>
          <tr style="height: 30px">
            <td
              width="143"
              style="
                border-right: 1px solid black;
                border-bottom: 1px solid black;
                border-left: 1px solid black;
                border-image: initial;
                border-top: none;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >车主服务</span
                >
              </p>
            </td>
            <td
              width="175"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid black;
                border-right: 1px solid black;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >1.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >道路救援:手机号码,姓名,车牌号,车架号,保单号,订单生效时间,订单到期日期,服务类型、承保机构、身份证号、救援位置、用户GPS定位信息、服务号</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >2.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >全程托付：用户GPS定位信息、车牌号、手机号、取车时间、取车地点、送车时间、送车地点</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >3.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >智慧工地：保单号、报案人姓名、联系电话、用户GPS定位信息、
                  用户居住小区名称</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >4.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >自助验车：用户GPS定位信息、车架号照片、车辆左前方照片、车辆右前方照片、车辆左后方照片、车辆右后方照片、身份证正面照片、身份证背面照片、行驶证首页照片、行驶证副页照片、新车合格证照片</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >5.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >配送查询：车牌号、被保险人证件号</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >6.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >年检换帖：车牌号、保单号、手机号、身份证正面照片、身份证背面照片、行驶证首页照片、行驶证副页照片、车主驾驶证照片</span
                >
              </p>
            </td>
            <td
              width="148"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid black;
                border-right: 1px solid black;
                padding: 0px 7px;
              "
            >
              <p
                style="
                  margin-bottom: 45px;
                  line-height: 16px;
                  text-autospace: none;
                "
              >
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >1.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >用于确认救援申请人的真实身份信息、求救车辆信息和查询救援地</span
                >
              </p>
              <p
                style="
                  margin-bottom: 45px;
                  line-height: 16px;
                  text-autospace: none;
                "
              >
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >2.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >用于确认申请全程托付服务的车辆及申请人的本人信息，实现服务的正常执行</span
                >
              </p>
              <p
                style="
                  margin-bottom: 45px;
                  line-height: 16px;
                  text-autospace: none;
                "
              >
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >3-5.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >用于确认车辆、车主或被保险人的真实性并提供服务</span
                >
              </p>
              <p
                style="
                  margin-bottom: 45px;
                  line-height: 16px;
                  text-autospace: none;
                "
              >
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >6.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >用于提供年检换帖服务</span
                >
              </p>
            </td>
          </tr>
          <tr style="height: 30px">
            <td
              width="143"
              style="
                border-right: 1px solid black;
                border-bottom: 1px solid black;
                border-left: 1px solid black;
                border-image: initial;
                border-top: none;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >生活服务（证件夹）</span
                >
              </p>
            </td>
            <td
              width="175"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid black;
                border-right: 1px solid black;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >1.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >证件夹-车辆合格证：车辆合格证照片、合格证编号、车型、车架号、发动机号、发证日期</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >2.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >证件夹-身份证：身份证头像页照片、身份证国徽页照片、姓名、身份证号、生效日期、失效日期</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >3.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >证件夹-驾驶证：驾驶证主页照片、</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >驾驶证副页照片、姓名、证件号、</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >准驾车型、生效日期、失效日期</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >4.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >证件夹-行驶证：行驶证主页照片、</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >行驶证副页照片、车牌号、所有人、</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >品牌型号、车架号、发动机号、车辆类型、座位人数、注册日期</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >5.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >证件夹-银行卡：银行卡正面照片、银行卡反面照片</span
                >
              </p>
            </td>
            <td
              width="148"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid black;
                border-right: 1px solid black;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >用于用户自主维护信息及备忘</span
                >
              </p>
            </td>
          </tr>
          <tr style="height: 30px">
            <td
              width="143"
              style="
                border-right: 1px solid black;
                border-bottom: 1px solid black;
                border-left: 1px solid black;
                border-image: initial;
                border-top: none;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >我的礼包</span
                >
              </p>
            </td>
            <td
              width="175"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid black;
                border-right: 1px solid black;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >1.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >健康关怀:手机号码,姓名,证件类型,证件号码,保单号,保单生效日期,保单到期日期,订单生效时间,订单到期日期,服务类型,保额,免赔额,归属地,投保人出生日期,投保人性别,被保人出生日期,被保人性别,服务包ID</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >2.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >安全检测:手机号码,车牌号,车架号,保单号,订单生效时间,订单到期日期,服务类型</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >3.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >洗车:手机号码,车牌号,订单生效时间,订单到期日期,服务类型</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >4.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >停车服务:手机号码,订单生效时间,订单到期日期,服务类型</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >5.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >热门观影:手机号码,订单生效时间,订单到期日期,服务类型</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >6.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >优惠加油:手机号码,订单生效时间,订单到期日期,服务类型</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >7.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >代步车:手机号码,订单生效时间,订单到期日期,服务类型</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >8.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >汽车保养:手机号码,车牌号,订单生效时间,订单到期日期,服务类型</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >9.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >快修喷漆:手机号码,车牌号,订单生效时间,订单到期日期,服务类型</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >10.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >生活服务:手机号码,订单生效时间,订单到期日期,服务类型</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >11.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >车辆年检:手机号码,姓名,车牌号,车架号,发动机号,保单号,初登日期,保单生效日期,保单到期日期,订单生效时间,订单到期日期,服务类型</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >12.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >实物:手机号码,姓名,订单生效时间,订单到期日期,服务类型</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >13.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >违章查询:车牌号,车架号,发动机号,订单生效时间,订单到期日期,服务类型</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >14.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >违章代缴:手机号码,姓名,证件类型,证件号码,车牌号,车架号,发动机号,订单生效时间,订单到期日期,服务类型</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >15.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >机场贵宾:手机号码,姓名,证件类型,证件号码,订单生效时间,订单到期日期,服务类型</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >16.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >法律援助:手机号码,姓名,订单生效时间,订单到期日期,服务类型</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >17.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >代驾服务:手机号码,姓名,车牌号,车架号,保单号,订单生效时间,订单到期日期,服务类型</span
                >
              </p>
              <p style="line-height: normal; text-autospace: none">
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >18.</span
                ><span
                  style="font-size: 14px; font-family: 宋体; color: #525252"
                  >我的卡券：地理位置、手机号、证件号、车牌号、人脸照片</span
                >
              </p>
            </td>
            <td
              width="148"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid black;
                border-right: 1px solid black;
                padding: 0px 7px;
              "
            >
              <p
                style="
                  margin-bottom: 45px;
                  line-height: 16px;
                  text-autospace: none;
                "
              >
                <span style="font-size: 14px; font-family: 宋体; color: #525252"
                  >从公司系统中查询获取，不同服务项目使用信息字段不同，用于查看服务权益，并为您完成相应增值服务和卡券服务</span
                >
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p style="text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312">&nbsp;</span>
      </p>
      <p style="text-indent: 32px; text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（2）开启相关设备权限
        </span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >您需要在您的设备中向我们开启设备状态、网络数据、摄像头、录制音频、已安装应用列表、地理位置、存储、相册、电话访问权限，以收集和使用保险周边服务对应服务所需要的个人信息。您开启这些访问权限即代表您同意提供或授权我们可以收集和使用这些个人信息来实现上述功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集您的这些个人信息，也无法为您提供与这些授权所对应功能相关的服务。除上述权限之外，您可自主选择是否额外授予本微信公众号其他的系统权限。</span
        >
      </p>
      <p style="text-indent: 32px; text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312">2.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们如何使用您的个人信息</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >对于必要的个人信息，我们会用来提供该项业务功能，包括车主服务、生活服务、我的礼包。我们也会使用上述个人信息来维护和改进本项业务功能。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">3.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们如何委托处理、共享、转让或公开披露您的个人信息</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（1）委托处理</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >本业务功能中某些具体的模块或功能由外部供应商提供。例如我们会聘请服务提供商来协助我们提供客户支持。对我们委托处理个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的要求、本个人信息保护政策以及其他任何相关的保密和安全措施来处理个人信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">（2）共享</span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们不会与其它公司、组织和个人共享您的个人信息，但以下情况除外：</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">a</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）在获取授权同意的情况下共享：获得您的单独同意后，我们可在人保集团内部（范围详见下文“关键词解释”）或与授权合作伙伴（范围见下文）共享您的个人信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >人保集团内部共享：为了提升客户服务水平和用户体验，向您提供保险周边服务，我们会将您的个人信息在人保集团内部进行共享。<strong
            >保险周边服务由人保集团内部子公司提供，因此，我们需要将您的个人信息及保险标的信息提供给人保集团相应子公司以为您提供服务，</strong
          ></span
        ><strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >包括<a href="https://www.picc.com/"
              ><span style="color: windowtext; text-underline: none"
                >中国人民保险集团股份有限公司</span
              ></a
            >、<a
              href="https://www.picc.com/gyrb/jtjs/zgsjs/202109/t20210917_28850.html"
              ><span style="color: windowtext; text-underline: none"
                >中国人民人寿保险股份有限公司</span
              ></a
            >、<a
              href="https://www.picc.com/gyrb/jtjs/zgsjs/202109/t20210917_28847.html"
              ><span style="color: windowtext; text-underline: none"
                >中国人民健康保险股份有限公司</span
              ></a
            >、<a
              href="https://www.picc.com/gyrb/jtjs/zgsjs/202109/t20210917_28846.html"
              ><span style="color: windowtext; text-underline: none"
                >中国人民养老保险有限责任公司</span
              ></a
            >、<a
              href="https://www.picc.com/gyrb/jtjs/zgsjs/202109/t20210917_28841.html"
              ><span style="color: windowtext; text-underline: none"
                >人保金融服务有限公司</span
              ></a
            >、<a
              href="https://www.picc.com/gyrb/jtjs/zgsjs/202203/t20220314_42081.html"
              ><span style="color: windowtext; text-underline: none"
                >人保信息科技有限公司</span
              ></a
            >，您可点击查看相关公司具体介绍。</span
          ></strong
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >前述涉及公司的介绍会在使用相关服务的跳转页面注明。我们只会共享必要的个人信息，且这种共享受本政策所声明目的约束。人保集团内部其他成员如要改变本隐私政策声明的个人信息使用目的，将再次征求您的授权同意。除非得到您的明确授权或根据相关法律法规及监管规定要求，我们绝不会在未经您同意的情况下在人保集团内部共享您的敏感个人信息。</span
        >
      </p>
      <p style="text-indent: 32px; text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >与授权合作伙伴共享：仅为实现本政策声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与授权合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验（<a
          ></a
          ><a>技术服务合作详见下文“SDK使用情况”</a
          >）。目前，我们会在以下情形中，向您征求您对共享个人信息的授权同意：</span
        >
      </p>
      <p style="text-indent: 32px; text-autospace: none">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >第一、为使您能够使用和享受更多的服务及功能，我们会在应用中嵌入我们合作伙伴的服务。您在使用我们合作伙伴提供的车主服务、健康服务、生活服务和我的礼包时，会再次独立征求您的授权。第二、为准确核实您的身份信息，确保您的账号和服务权益安全，以便为您提供服务，您同意并授权我们将您的人脸信息提供给公安部进行身份验证。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们的授权合作伙伴无权将共享的个人信息用于任何其他用途。除非得到您的明确授权或相关法律法规及监管规定要求，我们绝不会在未经您同意的情况下与授权合作伙伴共享您的敏感个人信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">b</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）对与我们共享您的个人信息的授权合作伙伴，我们将与其签署严格的保密协议，要求其在合作结束后将您的个人信息交还我们保存，同时删除其保存的相应个人信息副本并允许我们进行核查。对于人保集团内部其他成员，我们也会要求其严格执行人保集团的个人信息保密制度。人保集团内部其他成员和授权合作伙伴将按照本隐私政策规定，并采取有效的保密和安全措施来处理个人信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">c</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）匿名化处理后共享：根据《中华人民共和国网络安全法》《中华人民共和国个人信息保护法》等法律规定，无法识别自然人个人身份的信息不属于个人信息。因此，如我们对您的个人信息进行匿名化处理，无法识别或关联特定个人且不能复原的，依法可在人保集团内部或与其他方共享。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">d</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）根据法律法规或按政府主管部门的强制性要求对外提供或共享：例如，根据网络服务实名制管理要求和金融监管机构相关规定，为保证我们为您提供服务的连续性、真实性，我们需要将您的您的身份信息（姓名、证件类型、证件号、手机号、地理位置/GPS定位信息等）提交给政府主管部门或其指定的相关机构对您的个人信息进行核验；将您及出险人的身份信息（包括姓名、证件号码等），按监管机构要求向保单登记平台进行数据报送。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">（3）转让</span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们不会将您的个人信息转让给任何公司、组织和个人，但以下情形除外：</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">a</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；我们将向您告知接收方的名称或者姓名、联系方式、处理目的、处理方式和个人信息的种类，接收方不得超出上述权限处理您的个人信息，除非重新取得您的同意。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">b</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此个人信息保护政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（4）公开披露</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们不会公开披露您的个人信息，但以下情况除外：</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">a</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）获得您明确同意后；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">b</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）基于法律要求的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >4.</span
          ></strong
        ><strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >敏感个人信息的处理规则</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >对于保险周边服务收集的敏感个人信息，我们将采用采用首次进入弹窗、登录时提示、独立授权页面等方式向您进行告知，并取得您的单独同意，并明确告知您拒绝提供或者拒绝同意将带来的影响，例如您将无法使用相应的业务功能，以确保您在完全知情的基础上决定是否提供或授权我们查询、收集、共享您的敏感个人信息。</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >法律、行政法规对处理敏感个人信息规定应当取得相关行政许可或者作出其他限制的，我们将按照其规定处理。</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >&nbsp;</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span
          style="font-size: 16px; font-family: 仿宋_GB2312; color: windowtext"
          >□<strong>内容资讯与活动服务的个人信息收集使用规则</strong></span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">1.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们收集哪些您的个人信息</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（1）我们提供的业务功能需要依赖部分信息才得以运行。您选择使用该项业务功能，则需要向我们提供或允许我们收集的必要信息包括：</span
        >
      </p>
      <table
        cellspacing="0"
        cellpadding="0"
        style="border-collapse: collapse; margin-left: 0px; width: 100%"
      >
        <tbody>
          <tr style="height: 30px" class="firstRow">
            <td width="143" style="border: 1px solid black; padding: 0px 7px">
              <p
                style="
                  text-align: center;
                  line-height: normal;
                  text-autospace: none;
                "
              >
                <strong
                  ><span style="font-size: 14px; font-family: 宋体"
                    >功能模块</span
                  ></strong
                >
              </p>
            </td>
            <td
              width="175"
              style="
                border-top: 1px solid black;
                border-right: 1px solid black;
                border-bottom: 1px solid black;
                border-image: initial;
                border-left: none;
                padding: 0px 7px;
              "
            >
              <p
                style="
                  text-align: center;
                  line-height: normal;
                  text-autospace: none;
                "
              >
                <strong
                  ><span style="font-size: 14px; font-family: 宋体"
                    >收集个人信息</span
                  ></strong
                >
              </p>
            </td>
            <td
              width="148"
              style="
                border-top: 1px solid black;
                border-right: 1px solid black;
                border-bottom: 1px solid black;
                border-image: initial;
                border-left: none;
                padding: 0px 7px;
              "
            >
              <p
                style="
                  text-align: center;
                  line-height: normal;
                  text-autospace: none;
                "
              >
                <strong
                  ><span style="font-size: 14px; font-family: 宋体"
                    >用途</span
                  ></strong
                >
              </p>
            </td>
          </tr>
          <tr style="height: 30px">
            <td
              width="143"
              style="
                border-right: 1px solid black;
                border-bottom: 1px solid black;
                border-left: 1px solid black;
                border-image: initial;
                border-top: none;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-family: 宋体">线上活动</span>
              </p>
            </td>
            <td
              width="175"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid black;
                border-right: 1px solid black;
                padding: 0px 7px;
              "
            >
              <p style="line-height: normal; text-autospace: none">
                <span style="font-family: 宋体"
                  >姓名、手机号、证件号、保单相关信息、注册会员时间</span
                >/<span style="font-family: 宋体"
                  >地域、理赔情况、线上服务使用情况、增值服务使用情况、</span
                >GPS<span style="font-family: 宋体">定位信息</span>
              </p>
            </td>
            <td
              width="148"
              style="
                border-top: none;
                border-left: none;
                border-bottom: 1px solid black;
                border-right: 1px solid black;
                padding: 0px 7px;
              "
            >
              <p
                style="
                  margin-bottom: 45px;
                  line-height: 16px;
                  text-autospace: none;
                "
              >
                <span style="font-family: 宋体"
                  >用以帮助帮助用户参加各类营销和服务活动</span
                >
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p style="text-align: justify; text-justify: inter-ideograph">
        <span style="font-size: 16px; font-family: 仿宋_GB2312">&nbsp;</span>
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（2）开启相关设备权限
        </span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >您需要在您的设备中向我们开启设备状态、网络数据、摄像头、录制音频、已安装应用列表、地理位置/GPS定位信息、存储、相册、电话访问权限，以收集和使用内容资讯与活动对应服务所需要的个人信息。您开启这些访问权限即代表您同意提供或授权我们可以收集和使用这些个人信息来实现上述功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集您的这些个人信息，也无法为您提供与这些授权所对应功能相关的服务。除上述权限之外，您可自主选择是否额外授予本微信公众号其他的系统权限。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">2.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们如何使用您的个人信息</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >对于必要的个人信息，我们会用来提供该项业务功能，包括卡券礼包、营销活动。我们也会使用上述个人信息来维护和改进本项业务功能。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">3.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们如何委托处理、共享、转让或公开披露您的个人信息</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（1）委托处理</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >本业务功能中某些具体的模块或功能由外部供应商提供。例如我们会聘请服务提供商来协助我们提供客户支持。对我们委托处理个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的要求、本个人信息保护政策以及其他任何相关的保密和安全措施来处理个人信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">（2）共享</span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们不会与其它公司、组织和个人共享您的个人信息，但以下情况除外：</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">a</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）在获取授权同意的情况下共享：获得您的单独同意后，我们可与授权合作伙伴共享您的个人信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >与授权合作伙伴共享：</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >仅为实现本政策声明的目的，我们的某些服务将由授权合作伙伴提供，我们可能会与授权合作伙伴共享您的某些个人信</span
        ><span
          style="font-size: 16px; font-family: 仿宋_GB2312; color: windowtext"
          >息，以提供更好的客户服务和用户体验</span
        ><strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >。</span
          ></strong
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >目前，我们会在以下情形中，向您征求您对共享个人信息的授权同意：</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >您选择参与我们和第三方联合开展的活动，我们可能与其共享活动过程中产生的、为完成活动所必要的信息，以便第三方能及时向您发放奖品或为您提供服务，我们会依据法律法规或国家标准的要求，在活动规则页面或通过其他途径向您明确告知第三方姓名或名称、联系方式等信息以及需要向第三方提供何种个人信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们的授权合作伙伴无权将共享的个人信息用于任何其他用途。除非得到您的明确授权或相关法律法规及监管规定要求，我们绝不会在未经您同意的情况下与授权合作伙伴共享您的敏感个人信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">b</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）对与我们共享您的个人信息的授权合作伙伴，我们将与其签署严格的保密协议，要求其在合作结束后将您的个人信息交还我们保存，同时删除其保存的相应个人信息副本并允许我们进行核查。授权合作伙伴将按照本隐私政策规定，并采取有效的保密和安全措施来处理个人信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">c</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）匿名化处理后共享：根据《中华人民共和国网络安全法》《中华人民共和国个人信息保护法》等法律规定，无法识别自然人个人身份的信息不属于个人信息。因此，如我们对您的个人信息进行匿名化处理，无法识别或关联特定个人且不能复原的，依法可在人保集团内部或与其他方共享。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">d</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）根据法律法规或按政府主管部门的强制性要求对外提供或共享：例如，根据网络服务实名制管理要求和金融监管机构相关规定，为保证我们为您提供服务的连续性、真实性，我们需要将您的身份信息（姓名、证件类型、证件号、手机号、地理位置）提交给政府主管部门或其指定的相关机构对您的个人信息进行核验；将您及出险人的身份信息（包括姓名、证件号码等），按监管机构要求向保单登记平台进行数据报送。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">（3）转让</span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们不会将您的个人信息转让给任何公司、组织和个人，但以下情形除外：</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">a</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；我们将向您告知接收方的名称或者姓名、联系方式、处理目的、处理方式和个人信息的种类，接收方不得超出上述权限处理您的个人信息，除非重新取得您的同意。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">b</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此个人信息保护政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（4）公开披露</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们不会公开披露您的个人信息，但以下情况除外：</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">a</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）获得您明确同意后；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">b</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >）基于法律要求的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >&nbsp;</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >4.</span
          ></strong
        ><strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >敏感个人信息的处理规则</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >对于内容资讯与活动功能收集的敏感个人信息，我们将采用首次进入弹窗、登录时提示等方式向您进行告知，并取得您的单独同意，并明确告知您拒绝提供或者拒绝同意将带来的影响，例如您将无法使用相应的业务功能，以确保您在完全知情的基础上决定是否提供或授权我们查询、收集、共享您的敏感个人信息。</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >法律、行政法规对处理敏感个人信息规定应当取得相关行政许可或者作出其他限制的，我们将按照其规定处理。</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >&nbsp;</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >□<strong>安全管理、权限获取说明及SDK使用情况</strong></span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">1.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >安全管理说明</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >在您使用本微信公众号浏览、搜索信息，或者接受我们提供的各项服务时，为保障我们向您提供的服务稳定运行，我们会收集您的个人设备相关信息，以验证您的真实用户身份，或者协助我们履行网络与数据安全相关法律义务，记录网络运行状态并形成系统操作日志等。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >在前述情形下，我们可能收集的个人设备信息，包括设备型号、操作系统、地理位置、唯一设备标识符、手机号、登录IP地址、接入网络方式、类型和状态、网络质量数据、操作日志、服务故障信息，这些信息是为提供安全服务必要收集的信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >为了记录这些信息，我们同时可能会获取您读取手机状态的相关权限，如您不同意我们记录这些信息，可能导致您因无法通过相应风控验证而使得中国人保财险官方微信公众号
          中对应需要完成风控验证的功能或者服务受到影响，但同样不影响您正常使用其他功能。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">2.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >权限获取说明</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >为了向您提供服务，本微信公众号可能需要在必要范围内向您申请获取以下权限。您开启这些访问权限即代表您同意提供或授权我们才可以收集和使用这些个人信息来实现上述功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集您的这些个人信息，也无法为您提供与这些授权所对应功能相关的服务。</span
        >
      </p>
      <p style="text-indent: 32px">
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >（1）基于设备状态的扩展功能：包括设备信息（设备型号、操作系统）、地理位置、手机号、登录IP地址、接入网络方式、类型和状态、网络质量数据、操作日志、服务故障信息、运营商在内的描述个人常用设备基本情况的信息、接入网络的方式、类型和状态、网络质量数据、设备所在地理位置相关信息（IP地址、GPS位置信息以及WLAN接入点、蓝牙和基站传感器信息），以保证账号登录的安全性，贴切用户的需求，了解产品的适配性、识别账号的异常状态；同时为保障网络安全或运营安全，我们会收集、汇总、记录信息。拒绝授权后，本微信公众号将不读取设备状态，但不影响您正常使用本微信公众号的其他可用的功能。对于从您的各种设备上收集到的信息，我们可能会将它们进行关联，以便我们能在这些设备上为您提供一致的服务。我们可能会将您的设备信息或电话号码与您的帐户关联。同时，请您理解，当您将处于设备屏幕中的中国人保财险微信公众号切换到设备后台运行时，由于部分设备机型及系统原因，您此前使用中国人保财险微信公众号相关功能而产生的信息收集行为，可能无法立即停止，从而导致短暂的后台信息收集行为。</span
          ></strong
        >
      </p>
      <p style="text-indent: 32px">
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >（2）基于存储权限的扩展功能：</span
          ></strong
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >在您开启存储权限后，我们将用于缓存您在使用中国人保财险微信公众号过程中产生的文本、图像、视频内容。拒绝授权后，中国人保财险官方微信公众号将不读取存储信息，不影响您正常使用中国人保财险官方微信公众号的其他功能。</span
        >
      </p>
      <p style="text-indent: 32px">
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >（3）基于摄像头的扩展功能：</span
          ></strong
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >您在开启摄像头权限后，我们将用于证件识别、扫码、人脸核身、理赔申请材料上传、设置头像、意见反馈、评价、客服问答、人脸识别登录/认证、头像设置。拒绝授权后，上述功能将无法使用。</span
        >
      </p>
      <p style="text-indent: 32px">
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >（4）基于相册的扩展功能：</span
          ></strong
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >用于上传照片设置您的头像、理赔申请材料上传、意见反馈、评价、客服问答。拒绝授权后，上述功能将无法使用。</span
        >
      </p>
      <p style="text-indent: 32px">
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >（5）基于电话的扩展功能：</span
          ></strong
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >该功能用于道路救援、报案理赔、网点服务、人工客服拨打电话，拒绝授权后，上述功能将无法使用。</span
        >
      </p>
      <p style="text-indent: 32px">
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >（6）基于地理位置的扩展功能：</span
          ></strong
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >当您使用本微信公众号出险理赔、网点预约、道路救援、展现城市服务，我们会获取您所在地理位置完成上述功能。</span
        >
      </p>
      <p style="text-indent: 32px">
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >（7）基于网络数据的扩展功能：</span
          ></strong
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >允许程序访问Wi-Fi网络状态信息，此权限为系统默认权限，只有您开启数据权限访问本微信公众号时会使用到。该权限我们只会在首次启动本微信公众号时收集一次。</span
        >
      </p>
      <p style="text-indent: 32px">
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >（8）基于已安装应用列表的扩展功能：</span
          ></strong
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >您在使用微信登录、支付、分享时，检测是否安装相应应用。如您拒绝授权应用列表权限，本微信公众号将不读取应用列表内容，但不影响您正常使用本微信公众号的其他功能。</span
        >
      </p>
      <p style="text-indent: 32px">
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >（9）基于录制音频权限的扩展功能：</span
          ></strong
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >当您使用实名认证、人脸核身功能时，根据提示语音验证活体。拒绝授权后，上述功能将无法使用。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >3. SDK</span
          ></strong
        ><strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >使用及委托处理</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >本平台某些具体的模块或功能由外部供应商提供。对我们委托处理个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的要求、本个人信息保护政策以及其他任何相关的保密和安全措施来处理个人信息。<strong
            >Android端使用的SDK如下：</strong
          ></span
        >
      </p>
      <p style="text-indent: 32px">
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >（1）微信&nbsp;&nbsp;
          </span></strong
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >功能：用于微信登录、微信支付、微信分享功能
        </span>
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >收集个人信息字段：订单信息（交易金额、订单号、时间）、手机号码、地理位置、联网信息、版本、设备版本、设备应用安装列表、发送/接收短信、Wifi信息、ssid、MAC地址、bssid</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >所属机构：深圳市腾讯计算机系统有限公司</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312">隐私协议：</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >http://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&amp;t=weixin_agreement&amp;s=privacy</span
        >
      </p>
      <p style="text-indent: 32px">
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >（2）支付宝SDK</span
          ></strong
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >功能：用于支付宝支付功能</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >收集个人信息字段：订单信息（交易金额、订单号、时间）、设备信息、手机号码、地理位置、联网信息</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >所属机构：支付宝（杭州）信息技术有限公司</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312">隐私协议：</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >https://render.alipay.com/p/c/k2cx0tg8</span
        >
      </p>
      <p style="text-indent: 32px">
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >（3）高德地图&nbsp;&nbsp;
          </span></strong
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >功能：用于GPS定位和IP定位展示场景
        </span>
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >收集个人信息字段：设备信息【如IP
          地址、GNSS信息、WiFi状态、WiFi参数、WiFi列表、SSID、BSSID、基站信息、信号强度的信息、蓝牙信息、传感器信息（矢量、加速度、压力）、设备信号强度信息、外部存储目录】</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >所属机构：高德软件有限公司</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312">隐私</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312">协议</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >：<a href="https://lbs.amap.com/pages/privacy/"
            ><span style="color: black; text-underline: none"
              >https://lbs.amap.com/pages/privacy/</span
            ></a
          ></span
        >
      </p>
      <p style="text-indent: 32px">
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >（4）百度地图&nbsp;&nbsp;
          </span></strong
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >功能：用于GPS定位和IP定位展示场景，线路规划、导航功能</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >收集个人信息字段：位置信息可能包括经纬度、GNSS信息、WiFi网关地址、WiFi
          MAC地址、WiFi信号强度、WiFi状态、WiFi参数、WiFi列表、基站ID数据信息、运营商信息、设备信号强度信息、IP地址、蓝牙信息和传感器信息（加速度，陀螺仪、方向、压力、旋转矢量、光照、磁力计）。设备信息包括设备标识信息（Android
          ID、IDFA、IDFV）、系统信息（操作系统版本、设备品牌及型号、设备配置）和应用信息（应用名）。网络类型如移动网络、WiFi网络。出发地-到达地，您输入的上车点、下车点信息，包括经纬度、地址信息。</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >所属机构：北京百度网讯科技有限公司</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312">隐私协议：</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >https://lbsyun.baidu.com/index.php?title=openprivacy</span
        >
      </p>
      <p style="text-indent: 32px">
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >（5）透视宝</span
          ></strong
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >功能：云平台、辅助运营，提供中国人保财险微信公众号网络数据、崩溃数据等采集功能</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >收集个人信息字段：个人信息字段、手机设备信息、网络信息</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >所属机构：云智慧（北京）科技有限公司</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312">隐私协议：</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >https://www.toushibao.com/privacy.html</span
        >
      </p>
      <p style="text-indent: 32px">
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >（6）信手书签名</span
          ></strong
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >功能：用于电子签名功能</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >收集个人信息字段：无</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >所属机构：北京数字认证股份有限公司</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312">隐私协议：</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >https://www.bjca.cn/</span
        >
      </p>
      <p style="text-indent: 32px">
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >（7）Insight SDK</span
          ></strong
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >功能：数据采集</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >收集个人信息字段：设备信息（设备名称、操作系统、设备分辨率、运营商名称）、账号信息、IDFA</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >所属机构：网舟联合科技（北京）有限公司</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312">隐私协议：</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >https://experienceleague.adobe.com/docs/mobile-services/android/gdpr-privacy-android/c-mob-privacy-gdpr-android.html?lang=en</span
        >
      </p>
      <p style="text-indent: 32px">
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >2.iOS</span
          ></strong
        ><strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >端使用的SDK如下：</span
          ></strong
        >
      </p>
      <p style="text-indent: 32px">
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >（1）微信&nbsp;&nbsp;
          </span></strong
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >功能：用于微信登录、微信支付、微信分享功能
        </span>
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >收集个人信息字段：订单信息（交易金额、订单号、时间）、手机号码、地理位置、联网信息、系统版本、设备版本、设备应用安装列表、发送/接收短信、Wifi信息、ssid、MAC地址、bssid</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >所属机构：深圳市腾讯计算机系统有限公司</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312">隐私协议：</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >http://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&amp;t=weixin_agreement&amp;s=privacy</span
        >
      </p>
      <p style="text-indent: 32px">
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >（2）支付宝SDK</span
          ></strong
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >功能：用于支付宝支付功能</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >收集个人信息字段：订单信息（交易金额、订单号、时间）、设备信息、手机号码、地理位置、联网信息</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >所属机构：支付宝（杭州）信息技术有限公司</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312">隐私协议：</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >https://render.alipay.com/p/c/k2cx0tg8</span
        >
      </p>
      <p style="text-indent: 32px">
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >（3）百度地图&nbsp;&nbsp;
          </span></strong
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >功能：用于GPS定位和IP定位展示场景，线路规划、导航功能</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >收集个人信息字段：位置信息可能包括经纬度、GNSS信息、WiFi网关地址、WiFi
          MAC地址、WiFi信号强度、WiFi状态、WiFi参数、WiFi列表、基站ID数据信息、运营商信息、设备信号强度信息、IP地址、蓝牙信息和传感器信息（加速度，陀螺仪、方向、压力、旋转矢量、光照、磁力计）。设备信息包括设备标识信息（Android
          ID、IDFA、IDFV）、系统信息（操作系统版本、设备品牌及型号、设备配置）和应用信息（应用名）。网络类型如移动网络、WiFi网络。出发地-到达地，您输入的上车点、下车点信息，包括经纬度、地址信息。</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >所属机构：北京百度网讯科技有限公司</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312">隐私协议：</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >https://lbsyun.baidu.com/index.php?title=openprivacy</span
        >
      </p>
      <p style="text-indent: 32px">
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >（4）透视宝</span
          ></strong
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >功能：云平台、辅助运营，提供中国人保财险微信公众号网络数据、崩溃数据等采集功能</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >收集个人信息字段：个人信息字段、手机设备信息、网络信息</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >所属机构：云智慧（北京）科技有限公司</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312">隐私协议：</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >https://www.toushibao.com/privacy.html</span
        >
      </p>
      <p style="text-indent: 32px">
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >（5）信手书签名</span
          ></strong
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >功能：用于电子签名功能</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >收集个人信息字段：无</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >所属机构：北京数字认证股份有限公司</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312">隐私协议：</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >https://www.bjca.cn/</span
        >
      </p>
      <p style="text-indent: 32px">
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >（6）Insight SDK</span
          ></strong
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >功能：数据采集</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >收集个人信息字段：设备信息（设备名称、操作系统、设备分辨率、运营商名称）、账号信息、IDFA</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >所属机构：网舟联合科技（北京）有限公司</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312">隐私协议：</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >https://experienceleague.adobe.com/docs/mobile-services/android/gdpr-privacy-android/c-mob-privacy-gdpr-android.html?lang=en</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >目前使用的第三方SDK仅为了实现业务功能所需，目的是为了保障我们能够快速、敏捷、安全的开发和迭代应用程序。只有在获得您的授权后，我们才可能会向第三方提供您的个人信息，当您退出此功能，我们将停止收集相关信息。如我们的授权合作伙伴需要通过应用程序接口（API）、软件工具开发包（SDK）获取您的信息，我们会对其进行严格的监控，并令其按照本隐私政策以及与授权伙伴约定的数据保护措施严格执行。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">&nbsp;</span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >□<strong>我们如何使用Cookie等技术</strong></span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >为使您获得更轻松的访问体验，我们会在您的移动设备上发送名为Cookie的小数据文件以识别您的身份。我们向您发送Cookie是为了简化您重复输入信息以登录账户的步骤、存储您的偏好设置、帮助判断您的登录状态以及账户或数据安全，目的是向您提供最友好、最安全的服务。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们不会将 Cookies
          用于本隐私政策所述目的之外的任何用途，我们发送给您的Cookie是唯一的，它只能被中国人保财险官方微信公众号服务器读取，您可根据自己的偏好管理或删除Cookies。您可以清除移动设备上保存的所有Cookie，此种除外情形下，可能会妨碍您安全的访问我们的平台接受服务。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >□<strong>我们如何保护您的个人信息</strong></span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span
          style="font-size: 16px; font-family: 仿宋_GB2312; color: windowtext"
          >我们采取以下措施保护您的个人信息：</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span
          style="font-size: 16px; font-family: 仿宋_GB2312; color: windowtext"
          >（一）我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权的访问、不当公开披露、不当使用、不当修改、损坏或丢失（以下简称“个人信息安全事件”）。我们会采取一切合理可行的措施，保护您的个人信息。例如，我们会采取权限控制、隐私保护培训等安全措施。
        </span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span
          style="font-size: 16px; font-family: 仿宋_GB2312; color: windowtext"
          >（二）我们遵守《数据安全法》要求，建立了严格的数据安全</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312">管理</span
        ><span
          style="font-size: 16px; font-family: 仿宋_GB2312; color: windowtext"
          >制度，严格履行数据安全保护义务，我们的信息系统已经通过国家公安部信息系统安全等级测试备案，并获得了由公安部门核准颁发的“国家信息安全等级保护三级认证”。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（三）我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（四）互联网并非绝对安全。电子邮件、即时通讯、社交软件等与其他用户的交流方式无法确定是否完全加密，我们建议您使用此类工具时使用复杂密码，协助我们保护您的账号和个人信息安全。
        </span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span
          style="font-size: 16px; font-family: 仿宋_GB2312; color: windowtext"
          >（五）我们将对个人信息保护影响评估报告至少保存三年。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（六）我们将尽力确保您提供或授权我们查询收集的任何个人信息的安全。如果我们的物理防护、技术手段或管理措施遭到破坏，导致个人信息安全事件发生，我们将依法承担相应的法律责任。
        </span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（七）在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施、我们的联系方式等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们采取措施能够有效避免信息泄露、篡改、丢失造成危害的，可以不通知您以上事项，但履行个人信息保护职责的国家部门认为可能造成危害的要求我们通知的，我们将尽快通知。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（八）我们会认真按照本隐私政策的约定使用您的个人信息。当我们要将您的个人信息用于本政策未载明的其它用途时，或将基于特定目的收集而来的信息用于其他目的时，我们会事先征求您的同意。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（九）在收集您的个人信息后，我们有可能通过技术手段对数据进行匿名化处理。经匿名化处理的信息将无法用来重新识别、关联您的身份。<strong
            >根据法律规定，我们有权使用、共享已经匿名化的个人信息，开展数据分析等商业化应用。</strong
          ></span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（十）当您使用产品和接受服务的过程中，需要使用手机等设备明确显示您的个人信息时，我们会采用包括去标识化、部分信息采用符号替换等方式处理您的信息，以保护您的信息安全。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（十一）如出现我们被收购、合并或破产清算情形，我们会要求收购人、存续公司、破产管理人等接受您个人信息的公司、组织继续受本隐私政策的约束，或者要求其重新获得您的授权同意。
        </span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >□<strong>您的权利 </strong></span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >（一）访问您的个人信息</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问<a
          ></a><a>（我司保留对路径调整的权利）</a>：</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">1.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >进入本微信公众号后，可访问“我的”—“会员中心”—“头像”，查看个人信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">2.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >进入本微信公众号后，可访问“我的”—“会员中心”，查看个人保单信息、理赔信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">3.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >进入本微信公众号后，可访问“我的”—“会员中心—”“我的授权”—“中国人民财险保险股份有限公司隐私政策”，查看我们如何收集和使用您的个人信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >如果您无法通过上述方式访问这些个人信息，您可以随时通过在线客服或拨打95518电话联系，我们将在15天内回复您的访问请求。对于您在使用我们的产品或服务过程中产生的其他个人信息，只要我们不需要过多投入或存在其他显著困难，我们会向您提供，否则我们将向您提供替代方法。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >（二）更正您的个人信息
          </span></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >当您发现我们处理的关于您的个人信息有错误时，您有权要求我们作出更正。您可以通过如下途径申请更正：</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">1.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >点击本微信公众号在线客服功能，向在线客服人员提出申请。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">2.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >如果您需要修改手机号等相关信息，您可以在账户设置中自行更改。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >如果您无法通过上述链接更正这些个人信息，您可以随时拨打95518电话联系，我们将在15天内回复您的更正请求。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >（三）删除您的个人信息
          </span></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >在以下情形中，您可以向我们提出删除个人信息的请求：</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">1.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >如果我们处理个人信息的行为违反法律法规；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">2.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >如果我们收集、使用您的个人信息，却未征得您的同意；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">3.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >如果我们处理个人信息的行为违反了与您的约定；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">4.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >如果您不再使用我们的产品或服务，或您注销了账号；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">5.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >如果我们不再为您提供产品或服务。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会停止除存储和采取必要的安全保护措施之外的处理，并在备份更新时删除这些信息。《中华人民共和国保险法》《中华人民共和国反洗钱法》等法律法规、监管规定要求我们继续保留您的相关个人信息情形除外。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >（四）改变您授权同意的范围</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >您可以通过在线客服、拨打95518、登陆本微信公众号个人中心或开启关闭设备权限等途径取消授权或变更授权范围。当您取消授权或变更授权范围后，我们将不再查询、收集、共享或公开披露您的相应个人信息。但根据本隐私政策，您将无法使用相应的业务功能接受服务。您取消授权或变更的决定，不会影响此前基于您的授权而开展的个人信息处理<strong
            >。</strong
          ></span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >如您对首页“保险推荐”、我的页“猜您喜欢”、车险投保完成页“为你推荐”展示的产品不感兴趣，需修改向您推荐展示的保险产品，您可在本微信公众号“我的-会员中心-我的授权-个性化推荐”进行设置。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >您可在本微信公众号，“我的”—“会员中心—”“我的授权”—“中国人民财险保险股份有限公司微信公众号隐私政策”查看或取消服务授权。后续您使用已取消授权的服务时，会再次独立征求您的授权。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >如果您拒绝接受我们给您发送的商业广告，您随时可通过以下方式取消：短信退订、邮件退订、客服电话、取消授权、注销账户等途径。但我们依照法律法规、监管规定或单项服务的服务协议约定发送消息的情形除外。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >（五）</span
          ></strong
        ><strong
          ><span
            style="font-size: 16px; font-family: 仿宋_GB2312; color: windowtext"
            >注销账户</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >您可以通过拨打95518、联系在线客服或在本微信公众号，“我的”—“会员中心”—“功能授权”—“账号注销”等途径申请注销此前注册的账户，您提交注销申请后，我们将尽快审核所涉及问题，在验证您的用户身份后的三天内完成账户注销（我司保留对注销路径调整的权利）。在您注销账户之后，我们将停止为您提供产品或服务，并依据您的要求删除您的个人信息，《中华人民共和国保险法》《中华人民共和国反洗钱法》等法律法规、监管规定另有规定的除外。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >（六）</span
          ></strong
        ><strong
          ><span
            style="font-size: 16px; font-family: 仿宋_GB2312; color: windowtext"
            >获取个人信息副本
          </span></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >您可以通过登录本微信公众号，进入“我的”-“会员中心”点击头像获得您的个人信息副本。在技术可行的前提下，如数据接口已匹配，我们还可按您的要求，直接将您的个人信息副本传输给您指定的第三方。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312"
            >（七）约束信息系统自动决策</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >在某些业务功能中，我们可能仅依据信息系统、算法等非人工自动决策机制做出决定。我们将保证决策的透明度和结果公平、公正，不对个人在交易价格等交易条件上实行不合理的差别待遇。通过自动化决策方式向个人进行信息推送、商业营销时，我们将通过中国人保财险微信公众号个人中心向您同时提供不针对您个人特征的选项，或者向您提供便捷的拒绝方式。如果这些决定对您的权益由重大影响，您有权要求我们做出解释，并有权拒绝我们通过自动化决策的方式作出决定。
        </span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（八）您有权要求我们对本隐私政策进行解释说明。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（九）您的近亲属为了自身的合法、正当利益，可以在您身故后对您的相关个人信息行使本章规定的查阅、复制、更正、删除等权利，您另有安排的除外。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 53px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（十）我们在以下情形中收集、使用您的以下个人信息无需征得您的授权同意：</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">1.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >与国家安全、国防安全直接相关的；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">2.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >与公共安全、公共卫生、重大公共利益直接相关的；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">3.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >与刑事侦查、起诉、审判和判决执行等直接相关的；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">4.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >依法维护您或其他人的生命、财产等重大合法权益所必需的但又很难得到本人授权同意的；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">5.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >您自行向社会公众公开或者其他已经合法公开的；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">6.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >从合法的新闻报道、政府信息公开等渠道公开披露的信息中收集的；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">7.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >根据您的要求与我们签订和履行合同所必需；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">8.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >用于维护我们所提供的产品及服务的安全稳定运行所必需的，例如发现、处置网络运营平台的故障；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">9.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >与我们履行法律法规规定的义务相关的；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">10.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >法律法规规定的其他情形。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们处理已公开的个人信息，对您的个人权益有重大影响的，将依照本隐私政策规定取得您的个人同意。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >（十一）<strong>您在</strong></span
        ><strong
          ><span
            style="font-size: 16px; font-family: 仿宋_GB2312; color: windowtext"
            >使用我们的产品及接受服务时所提供或授权我们查询收集的所有个人信息，将在您使用我们的产品及接受服务期间持续授权我们使用，除非您提交删除、撤回授权同意或注销账户申请（<a>《中华人民共和国保险法》《中华人民共和国反洗钱法》</a>等法律法规、监管规定另有规定的除外）并得到了我们的响应。</span
          ></strong
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span
          style="font-size: 16px; font-family: 仿宋_GB2312; color: windowtext"
          >（十二）响应您以上请求的方式</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于需要付出高额成本或存在其他显著困难的请求，我们将提供替代方法。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >在以下情形中，我们将无法响应您的请求：</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">1.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >与我们履行法律法规规定的义务相关的；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">2.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >与国家安全、国防安全直接相关的；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">3.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >与公共安全、公共卫生、重大公共利益直接相关的；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">4.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >与刑事侦查、起诉、审判和执行判决等直接相关的；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">5.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们有充分证据表明您存在主观恶意或滥用权利的；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">6.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您同意的；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">7.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">8.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >涉及商业秘密的。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >对于您的请求，我们将在15天内作出答复。如我们决定不响应您的请求，我们将向您告知该决定的理由。如您不满意，还可以通过拨打95518电话、在线客服的方式投诉。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">&nbsp;</span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >□<strong
            ><span style="color: black"
              >我们如何处理儿童的个人信息</span
            ></strong
          ></span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: black"
          >我们将根据国家关于未成年人网络保护的法律法规、监管规定处理未成年人的个人信息。我们的产品和服务主要面向成人。如果没有父母或者其他监护人的同意，儿童不得创建自己的用户账户。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: black"
          >对于经父母或其他监护人同意而收集儿童个人信息的情况，我们只会在法律法规、监管规定允许、父母或其他监护人明确同意或者保护儿童所必要的情况下使用或公开披露其个人信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: black"
          >如果我们发现自己在未事先获得可证实的父母或其他监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据，《中华人民共和国保险法》《中华人民共和国反洗钱法》等法律法规、监管规定另有规定的除外。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: black"
          >关于更多我们如何处理儿童信息的规则，可点击</span
        >
      </p>
      <p style="text-align: justify; text-indent: 32px">
        <span
          style="
            font-size: 16px;
            font-family: 仿宋_GB2312;
            color: black;
            text-decoration: none;
          "
          ><a
            href="https://smsp.epicc.com.cn/branches/webpage/webpage/picc-wangxiao/dealPrivacy/privacy_children.html"
            style="color: black"
            >《中国人民财产保险股份有限公司微信公众号儿童个人信息保护规则》</a
          ></span
        >
      </p>
      <p></p>
      <p style="text-indent: 32px; text-autospace: none">
        <strong
          ><span style="font-size: 16px; font-family: 仿宋_GB2312; color: black"
            >&nbsp;</span
          ></strong
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >□<strong>您的个人信息如何在全球范围转移 </strong></span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: black"
          >我们在中华人民共和国境内收集、产生的个人信息和重要数据将在境内存储。如因业务需要，确需向境外提供的，我们将通过国家网信部门组织的安全评估，或按照国家网信部门的规定经专业机构进行个人信息保护认证，或按照国家网信部门制定的标准合同与境外接收方订立合同约定双方的权利和义务，或满足法律、行政法规或者国家网信部门规定的其他条件。中华人民共和国缔结或者参加的国际条约、协定对向中华人民共和国境外提供个人信息的条件等有规定的，我们将按照其规定执行。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: black"
          >我们将采取必要措施，确保您的个人信息得到在中华人民共和国境内足够同等的保护。我们会请求您对跨境转移个人信息的单独同意，并向您告知境外接收方的名称或者姓名、联系方式、处理目的、处理方式、个人信息的种类以及个人向境外接收方行使隐私政策规定权利的方式和程序等事项，或者在跨境数据转移之前实施数据去标识化等安全举措。</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312">&nbsp;</span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >□<strong>本政策如何更新 </strong></span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们的隐私政策将适时更新。未经您同意，我们不会减少您按照本隐私政策所享有的权利。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >对于重大变更，我们还会通过首页弹窗、登录提示等方式为您提供更为显著的通知。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >本政策所指的重大变更包括但不限于：</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">1.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">2.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">3.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >个人信息共享、转让或公开披露的主要对象发生变化；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">4.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >您参与个人信息处理方面的权利及其行使方式发生重大变化；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">5.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们负责处理个人信息保护的责任部门、联络方式及投诉渠道发生变化时；</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">6.</span
        ><span style="font-size: 16px; font-family: 仿宋_GB2312"
          >个人信息安全影响评估报告表明存在高风险时。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们还会将本政策的旧版本存档，供您查阅。</span
        >
      </p>
      <p style="text-indent: 32px">
        <span style="font-size: 16px; font-family: 仿宋_GB2312">&nbsp;</span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >□<strong>如何联系我们</strong></span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >我们设置了个人信息保护的专门部门/专门岗位人员。如果您对本隐私政策有任何疑问或任何相关的投诉、意见，请通过拨打95518与我们联系，一般情况下，我们将在15天内回复。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以通过您所在管辖区的法院或政府相关管理机构等外部途径寻求解决方案。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >公司名称：中国人民财产保险股份有限公司</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >注册地址/常用办公地址：北京市朝阳区建国门外大街2号院2号楼</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >个人信息保护的专门岗位人员联系方式：95518</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312">&nbsp;</span>
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >□<strong><span style="color: black">关键词解释</span></strong></span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >人保集团：指中国人民保险集团股份有限公司及其作为控股股东、实际控制人的公司，包括但不限于中国人民保险集团股份有限公司、中国人民财产保险股份有限公司、中国人民人寿保险股份有限公司、中国人保资产管理有限公司、中诚信托有限责任公司、中国人民健康保险股份有限公司、中国人民养老保险有限责任公司、人保投资控股有限公司、人保资本保险资产管理有限公司、人保再保险股份有限公司、中国人民保险（香港）有限公司、人保金融服务有限公司、人保信息科技有限公司，以及上述公司直接或间接控股的公司。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: black"
          >个人信息：指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312; color: black"
          >敏感个人信息：指一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >自动化决策：是指通过计算机程序自动分析、评估个人的行为习惯、兴趣爱好或者经济、健康、信用状况等，并进行决策的活动。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >去标识化：是指个人信息经过处理，使其在不借助额外信息的情况下无法识别特定自然人的过程。</span
        >
      </p>
      <p
        style="
          text-align: justify;
          text-justify: inter-ideograph;
          text-indent: 32px;
          text-autospace: none;
        "
      >
        <span style="font-size: 16px; font-family: 仿宋_GB2312"
          >匿名化：是指个人信息经过处理无法识别特定自然人且不能复原的过程。</span
        >
      </p>
    </van-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
    };
  },
};
</script>

<style lang="less" scoped>
.insurance {
  /deep/.van-dialog__header {
    color: #323233;
    font-weight: 700;
    font-size: 17px;
  }
  /deep/.van-dialog__content {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    max-height: 60vh;
    padding: 8px 24px 26px 24px;
    overflow-y: auto;
    font-size: 14px;
    line-height: 20px;
    white-space: pre-wrap;
    text-align: center;
    word-wrap: break-word;
    -webkit-overflow-scrolling: touch;
  }
}
</style>